import { useMutation, useQueryClient } from "@tanstack/react-query";

import { VoucherCartQueries } from "./queries";
import { createVoucherCartCheckout, updateVoucherCart } from "./requests";

export const useCreateVoucherCheckout = () => {
  return useMutation({
    mutationFn: createVoucherCartCheckout,
  });
};

export const useUpdateVoucherCart = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVoucherCart,
    onSuccess: (data) => {
      queryClient.setQueryData(VoucherCartQueries.current.queryKey, (old) => {
        if (!old) return data;
        return { ...old, ...data };
      });
    },
  });
};
